import { UserRoleAssignment } from './UserRoleAssignment';
import { UserDetailsRoleType } from '../viewModels/Enums';

export default class UserDetailsRole {
  scope?: string;
  role?: string;
  type?: UserDetailsRoleType;
  parentDescription?: string;
  parentScope?: string;
  parentAssignment?: UserRoleAssignment;

  constructor(scope?: string, role?: string, parentAssignment?: UserRoleAssignment) {
    this.scope = scope;
    this.role = role;
    this.parentAssignment = parentAssignment;

    if (parentAssignment) {
      this.parentScope = parentAssignment.scope;
      this.type = UserDetailsRoleType.Inherited;
    } else {
      this.type = UserDetailsRoleType.Direct;
    }
  }
}
